
import Button from '../../../components/base/Button';
import Card from '../../../components/base/Card';

export default function IncubatorSection() {
  const features = [
    {
      icon: 'ri-funds-line',
      title: 'Funding Access',
      description: 'Connect with investors and secure capital for your AI venture through our network.'
    },
    {
      icon: 'ri-code-s-slash-line',
      title: 'Technical Resources',
      description: 'Access cutting-edge AI tools, infrastructure, and development expertise.'
    },
    {
      icon: 'ri-rocket-line',
      title: 'Brand & GTM Support',
      description: 'Professional branding, marketing strategy, and go-to-market execution.'
    },
    {
      icon: 'ri-exchange-line',
      title: 'Exit & Buyer Network',
      description: 'Direct access to our marketplace and network of qualified buyers.'
    }
  ];

  return (
    <section className="py-32 bg-gradient-to-br from-gray-950 via-black to-gray-950">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-20">
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-blue-500/10 border border-blue-500/20 backdrop-blur-sm mb-8">
            <i className="ri-lightbulb-line text-blue-400 mr-2"></i>
            <span className="text-sm font-medium text-blue-400">AI Incubator Program</span>
          </div>
          
          <h2 className="text-5xl md:text-6xl font-light text-white mb-8 tracking-tight">
            Launch or scale your
            <br />
            <span className="font-medium bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent">
              AI venture
            </span>
          </h2>
          
          <p className="text-xl text-gray-400 max-w-3xl mx-auto font-light leading-relaxed">
            Our incubator helps founders build, brand, and monetize their AI assets — from automation systems to SaaS platforms.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {features.map((feature, index) => (
            <Card key={index} className="group hover:scale-105 transition-all duration-300">
              <div className="p-8 text-center">
                <div className="w-16 h-16 mx-auto mb-6 bg-gradient-to-br from-blue-500/20 to-cyan-500/20 rounded-2xl flex items-center justify-center group-hover:from-blue-500/30 group-hover:to-cyan-500/30 transition-all duration-300">
                  <i className={`${feature.icon} text-2xl text-blue-400`}></i>
                </div>
                <h3 className="text-lg font-medium text-white mb-3">
                  {feature.title}
                </h3>
                <p className="text-gray-400 text-sm font-light leading-relaxed">
                  {feature.description}
                </p>
              </div>
            </Card>
          ))}
        </div>

        {/* CTA Section */}
        <div className="text-center">
          <div className="max-w-2xl mx-auto mb-12">
            <h3 className="text-2xl font-light text-white mb-4">
              Ready to build the next AI unicorn?
            </h3>
            <p className="text-gray-400 font-light">
              Join our selective incubator program and get the resources, network, and expertise to scale your AI business.
            </p>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button variant="primary" size="lg" className="min-w-52">
              Apply for Incubator
              <i className="ri-arrow-right-line ml-2"></i>
            </Button>
            <Button variant="outline" size="lg" className="min-w-52">
              Learn More
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
